<header-desktop *limitUp="DEVICE_SIZE.DESKTOP"></header-desktop>

<menu-desktop *limitUp="DEVICE_SIZE.DESKTOP"></menu-desktop>

<header-mobile *smallerThan="DEVICE_SIZE.DESKTOP"></header-mobile>

<menu-category-mobile *smallerThan="DEVICE_SIZE.DESKTOP"></menu-category-mobile>

<cx-page-layout section="bottomHeader"></cx-page-layout>
